// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app_static/" + chunkId + ".bundle." + {"860":"5a26c50d6a198bc1339b","912":"21a7c80bd238f206aecf"}[chunkId] + ".js";
};